import { getContext } from '@fiverr-private/fiverr_context';
import { sendMixPanelEvents } from '../lib/mixpanelEvents';
import reportEvent from '../lib/reportEvent';

export const sendBombaMixpanelEvent = (type, coupon, additionalParams = {}) => {
    const params = {
        'Flow': 'Receiving a coupon',
        'Bomba Type': 'Coupons',
        ...additionalParams
    };
    sendMixPanelEvents(type, params);
};

export const sendBombaBigQueryEvent = (type, { userId, sellerId, group, coupon }) => {
    const { pageCtxId } = getContext();
    const actionType = group === 'user_action' ? {
        action: {
            type: 'click'
        }
    } : {};
    const { couponId, code, deliveryPackId, discountValue } = coupon;
    const baseData = {
        userId,
        sellerId
    };
    const extra = {
        group,
        entity: 'client',
        event_source: 'seller_page',
        feature: {
            name: 'coupon'
        },
        page: {
            name: 'seller_page',
            ctx_id: pageCtxId
        },
        coupon: {
            type: 'seller_coupon',
            invitee_user_id: userId,
            id: couponId,
            promo_code: code,
            invitation_id: deliveryPackId,
            discount_percent: discountValue / 100
        },
        ...actionType
    };

    reportEvent(type, baseData, extra);
};
